import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/accordion/accordion.styles.ts
var accordion_styles_default = r` ${component_styles_default} :host { font-family: var(--sl-font-sans); } `;

export {
  accordion_styles_default
};
